import React, { useState } from 'react';
import ProjectDetails from './ProjectDetails';

const ProjectTabs = ({ projects }) => {
  const [activeTab, setActiveTab] = useState(0);

  if (!projects || projects.length === 0) {
    return null;
  }

  return (
    <div>
      {projects.length > 1 && (
        <div className="tabs">
          {projects.map((project, index) => (
            <button
              key={index}
              className={`tab ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {project.project_name || `Project ${index + 1}`}
            </button>
          ))}
        </div>
      )}

      <div className="tab-content">
        <ProjectDetails project={projects[activeTab]} />
      </div>
    </div>
  );
};

export default ProjectTabs;
